module.exports = __webpack_public_path__ + "img/cb-lr-y2.56b4c7e4.gif";